(() => {
  const ROOT_SELECTOR = '[data-paths-cart]';

  function initPathsCart(root) {
    if (!root || root.dataset.pathsCartInitialized === 'true') return;

    root.dataset.pathsCartInitialized = 'true';

    const sectionId = root.dataset.sectionId;

    let toastTimer = null;
    let requestInProgress = false;


    function showToast(message) {
      const toast = root.querySelector('[data-paths-cart-toast]');
      const toastText = root.querySelector('[data-paths-cart-toast-text]');

      if (!toast) return;

      window.clearTimeout(toastTimer);

      if (toastText && message) {
        toastText.textContent = message;
      }

      toast.classList.add('is-visible');

      toastTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2400);
    }


    function updateHeaderCartCount(itemCount) {
      document
        .querySelectorAll('[data-paths-cart-count]')
        .forEach((counter) => {
          counter.textContent = itemCount;

          counter.classList.toggle(
            'paths-header__cart-count--empty',
            itemCount === 0
          );
        });
    }


    function replaceCartSection(sectionHtml) {
      if (!sectionHtml) {
        window.location.reload();
        return;
      }

      const parser = new DOMParser();
      const parsedDocument = parser.parseFromString(
        sectionHtml,
        'text/html'
      );

      const newSection = parsedDocument.querySelector(
        `#shopify-section-${sectionId}`
      );

      const currentSection = document.querySelector(
        `#shopify-section-${sectionId}`
      );

      if (!newSection || !currentSection) {
        window.location.reload();
        return;
      }

      currentSection.replaceWith(newSection);

      const newRoot = newSection.querySelector(ROOT_SELECTOR);

      initPathsCart(newRoot);
    }


    async function parseResponse(response) {
      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to update your cart.'
        );
      }

      return data;
    }


    async function removeLine(button) {
      if (requestInProgress) return;

      const lineKey = button.dataset.lineKey;
      const item = button.closest('[data-paths-cart-item]');
      const loader = item?.querySelector('[data-paths-item-loader]');

      if (!lineKey) return;

      requestInProgress = true;

      item?.classList.add('is-loading');

      if (loader) {
        loader.hidden = false;
      }

      try {
        const response = await fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: 0,
            sections: [sectionId],
            sections_url: window.location.pathname,
          }),
        });

        const cart = await parseResponse(response);

        updateHeaderCartCount(cart.item_count);

        replaceCartSection(cart.sections?.[sectionId]);

      } catch (error) {
        item?.classList.remove('is-loading');
        showToast(error.message);
      } finally {
        requestInProgress = false;
      }
    }


    async function addUpsell(button) {
      if (requestInProgress || button.disabled) return;

      const variantId = Number(button.dataset.variantId);
      const label = button.querySelector('[data-paths-upsell-label]');

      if (!variantId) return;

      requestInProgress = true;

      button.disabled = true;
      button.classList.add('is-loading');

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
            sections: [sectionId],
            sections_url: window.location.pathname,
          }),
        });

        await parseResponse(response);

        const cartResponse = await fetch(`${window.routes.cart_url}.js`, {
          headers: {
            Accept: 'application/json',
          },
        });

        const cart = await parseResponse(cartResponse);

        updateHeaderCartCount(cart.item_count);

        if (label) {
          label.textContent = 'Added ✓';
        }

        showToast('Path added to your cart');

        window.setTimeout(async () => {
          try {
            const sectionResponse = await fetch(
              `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`
            );

            if (!sectionResponse.ok) {
              window.location.reload();
              return;
            }

            const sectionHtml = await sectionResponse.text();

            replaceCartSection(sectionHtml);
          } catch (error) {
            window.location.reload();
          }
        }, 650);

      } catch (error) {
        button.disabled = false;
        button.classList.remove('is-loading');

        if (label) {
          label.textContent = 'Add';
        }

        showToast(error.message);
        requestInProgress = false;
      }
    }


    root.addEventListener('click', (event) => {
      const removeButton = event.target.closest(
        '[data-paths-cart-remove]'
      );

      if (removeButton) {
        event.preventDefault();
        removeLine(removeButton);
        return;
      }

      const upsellButton = event.target.closest(
        '[data-paths-upsell-add]'
      );

      if (upsellButton) {
        event.preventDefault();
        addUpsell(upsellButton);
      }
    });
  }


  function initAllPathsCarts(scope = document) {
    scope
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initPathsCart);
  }


  window.PathsCart = {
    init: initPathsCart,
    initAll: initAllPathsCarts,
  };


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllPathsCarts();
    });
  } else {
    initAllPathsCarts();
  }


  document.addEventListener('shopify:section:load', (event) => {
    initAllPathsCarts(event.target);
  });
})();